<template>
  <b-field :label="label">
    <qd-taginput
      v-model="clientsSelected"
      icon="magnify"
      :data="filteredClients"
      autocomplete
      type="is-primary"
      dropdown-position="right"
      :loading="isFetchingClients"
      field="nomCommercial"
      @typing="getfilteredClients"
      :disabled="disabled">
      <template slot-scope="props">
        <div class="">
          <div class="media">
            <div class="media-content">
              <span class="has-text-weight-bold">
                {{ props.option.nomCommercial }}
              </span>
              <br>
              <span v-if="props.option.adresseString"
                    class="is-size-9 is-white-space-normal">
                  {{ props.option.adresseString }}
              </span>
              <br>
              <span v-if="props.option.compteComptable"
                class="is-size-9">
                  {{ props.option.compteComptable }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template slot="empty">
        <div v-if="!isFetchingClients">
            {{$t('general.autocomplete.noRslt')}}
        </div>
        <div v-else>
          {{$t('general.autocomplete.search')}}
        </div>
      </template>
    </qd-taginput>
  </b-field>
</template>
<script>
import { getAll } from '@/api/tiers';
import {
  TIERS_TYPE_CLIENT,
  TIERS_SOUS_TYPE_AUCUN,
} from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import debounce from 'lodash/debounce';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: false,
    },
    societeActiveId: {
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      filteredClients: [],
      isFetchingClients: false,
    };
  },
  computed: {
    clientsSelected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    getfilteredClients: debounce(async function getClients(search) {
      this.filteredClients = [];
      if (!search) return;
      this.isFetchingClients = true;
      try {
        const clients = (await getAll(
          {
            query: {
              auto: search,
              sousType: [TIERS_SOUS_TYPE_AUCUN],
              type: TIERS_TYPE_CLIENT,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        clients.forEach((client) => {
          if (adressFullStringGetter(client.adressePostale, false) !== '') {
            client.adresseString = adressFullStringGetter(client.adressePostale, false);
          }
        });
        this.filteredClients = clients.filter((client) => {
          return !this.clientsSelected.map(
            clientsSelected => clientsSelected.id,
          ).includes(client.id);
        });
        this.isFetchingClients = false;
      } catch (e) {
        this.isFetchingClients = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
  },
};
</script>
